import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

// 登录页
const Login = () => import('./views/login/Login.vue')
// 首页
const Home = () => import('./views/Home.vue')
// 欢迎页
const Welcome = () => import('./views/welcome/Welcome.vue')
const Capital = () => import('./views/welcome/Capital.vue')
const Statistics = () => import('./views/welcome/Statistics.vue')

// 代理列表
const Proxy = () => import('./views/proxy/Proxy.vue')
// 员工列表
const Staff = () => import('./views/staff/Staff.vue')
// 商家管理
const Merchant = () => import('./views/merchant/Merchant.vue')
// 合伙人管理
const Partner = () => import('./views/partner/Partner.vue')
// 房间管理
const Room = () => import('./views/room/Room.vue')

// 用户管理
const User = () => import('./views/user/User.vue')

// 设备管理
const Devices = () => import('./views/device/Devices.vue')
// 设备管理
const DeviceLog = () => import('./views/device/DeviceLog.vue')

// 资费管理
const Cost = () => import('./views/cost/Cost.vue')
// 预约订单管理
const Lease = () => import('./views/order/Lease.vue')
// 支付订单管理
const Pay = () => import('./views/order/Pay.vue')
// 退款订单管理
const Refund = () => import('./views/order/Refund.vue')
// 订单统计
const MerchantStatistics = () => import('./views/order/MerchantStatistics.vue')
// 未完结预授权
const Auth = () => import('./views/order/Auth.vue')

// 提现记录
const Withdraw = () => import('./views/withdraw/Withdraw.vue')
// 意见反馈
const Opinion = () => import('./views/opinion/Opinion.vue')
// 加盟申请
const JoinApplication = () => import('./views/joinApplication/JoinApplication.vue')
// 权限管理-资源
const SysPermission = () => import('./views/authority/SysPermission.vue')
// 权限管理-角色
const SysRole = () => import('./views/authority/SysRole.vue')
// 权限管理-用户
const SysUser = () => import('./views/authority/SysUser.vue')

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      redirect: '/welcome',
      children: [{
          path: '/welcome',
          name: 'welcome',
          component: Welcome
        },
        {
          path: '/capital',
          name: 'capital',
          component: Capital
        },
        {
          path: '/statistics',
          name: 'statistics',
          component: Statistics
        },
        {
          path: '/proxy',
          name: 'proxy',
          component: Proxy
        },
        {
          path: '/staff',
          name: 'staff',
          component: Staff
        },
        {
          path: '/merchant',
          name: 'merchant',
          component: Merchant
        },
        {
          path: '/partner',
          name: 'partner',
          component: Partner
        },
        {
          path: '/room',
          name: 'room',
          component: Room
        },
        {
          path: '/user',
          name: 'user',
          component: User
        },
        {
          path: '/devices',
          name: 'devices',
          component: Devices
        },
        {
          path: '/deviceLog',
          name: 'deviceLog',
          component: DeviceLog
        },
        {
          path: '/cost',
          name: 'cost',
          component: Cost
        },
        {
          path: '/lease',
          name: 'lease',
          component: Lease
        },
        {
          path: '/pay',
          name: 'pay',
          component: Pay
        },
        {
          path: '/refund',
          name: 'refund',
          component: Refund
        },
        {
          path: '/merchantStatistics',
          name: 'merchantStatistics',
          component: MerchantStatistics
        },
        {
          path: '/auth',
          name: 'auth',
          component: Auth
        },
        {
          path: '/withdraw',
          name: 'withdraw',
          component: Withdraw
        },
        {
          path: '/opinion',
          name: 'opinion',
          component: Opinion
        },
        {
          path: '/joinApplication',
          name: 'joinApplication',
          component: JoinApplication
        },
        // 权限
        {
          path: '/sysPermission',
          name: 'sysPermission',
          component: SysPermission
        },
        {
          path: '/sysRole',
          name: 'sysRole',
          component: SysRole
        },
        {
          path: '/sysUser',
          name: 'sysUser',
          component: SysUser
        }
      ]
    }
  ]
})

// 导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  //  from 代表从哪个路径跳转过来
  //  next 是一个函数,next()表示放行,next('/login') 强制跳转
  const accessToken = Cookies.get('token')
  if (to.path === '/login') {
    if (!accessToken) {
      return next()
    } else {
      return next('/home')
    }
  } else {
    if (!accessToken) {
      return next('/login')
    } else {
      return next()
    }
  }
})

export default router
